import { ProductCard } from '@/theme3/components/product/ProductCard';

export function FeaturedProductsSection({ featuredProducts = [] }) {
    return (
        <section className="relative overflow-hidden px-4 sm:px-6 lg:px-10">
            <div className="mx-auto w-full max-w-[1440px] rounded-[2.5rem] border border-rose-100/70 bg-[linear-gradient(180deg,#fff7fb_0%,#ffffff_34%,#fffdfa_100%)] px-4 py-6 shadow-[0_24px_80px_rgba(236,72,153,0.08)] sm:px-6 lg:px-8 lg:py-8">
                <div className="flex flex-wrap items-end justify-between gap-4">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-[#d80b67]">
                            Shop the look
                        </p>
                        <h2 className="mt-2 font-['Playfair_Display'] text-4xl font-black text-slate-900 sm:text-5xl">
                            Featured <span className="italic text-[#f51b75]">Products</span>
                        </h2>
                        <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600 sm:text-base">
                            Curated products for a softer, more editorial storefront with
                            clear purchase actions.
                        </p>
                    </div>
                </div>

                <div className="mt-6 grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
                    {featuredProducts.length ? (
                        featuredProducts.slice(0, 6).map((product, index) => (
                            <ProductCard
                                key={product.id ?? index}
                                product={product}
                                layout="landscape"
                                priceLabel="Starting from"
                            />
                        ))
                    ) : (
                        <EmptyState />
                    )}
                </div>
            </div>
        </section>
    );
}

function EmptyState() {
    return (
        <div className="col-span-full rounded-[1.5rem] border border-dashed border-rose-200 bg-rose-50/60 px-6 py-10 text-center text-sm text-slate-500">
            No featured products yet.
        </div>
    );
}
